import axios from "axios";
import Cookies from "js-cookie";

import { getSearchParamValue } from "../../../../../utils/helper/general";

export const addCompany = ({ requestPayload, userEmail }) =>
  axios.post(`${process.env.REACT_APP_API_GATEWAY}/companies`, requestPayload, {
    headers: {
      Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
    },
  });

export const addCompanyUser = ({ companyId, requestPayload, userEmail }) =>
  axios.post(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/users`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const addFavoriteFinancialProduct = ({ productId, userEmail }) =>
  axios.post(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/favoriteFinancialProducts/${productId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const addFavoriteSecurities = ({ productId, userEmail }) =>
  axios.post(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/favoriteSecurities/${productId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const addModel = ({ requestPayload, userEmail }) =>
  axios.post(
    `${process.env.REACT_APP_API_GATEWAY}/level/portfolioBuilder`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const archiveCompany = ({ companyId, userEmail }) =>
  axios.delete(`${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
    },
  });

export const archiveCompanyUser = ({ companyId, companyUserId, userEmail }) =>
  axios.delete(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/users/${companyUserId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const deleteModel = ({ modelId, userEmail }) =>
  axios.delete(
    `${process.env.REACT_APP_API_GATEWAY}/level/portfolioBuilder/${modelId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const generateJwtBySuperadmin = ({ clientEmail, userEmail }) =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/auth/V2/superauth`,
      {
        email: clientEmail,
      },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const getCompanyAll = ({ includeArchived, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/companies?includeArchived=${!!includeArchived}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response.data);

export const getCompanyById = ({ companyId, userEmail }) =>
  axios
    .get(`${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}`, {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    })
    .then(response => response.data);

export const getCompanyMarketingMaterials = ({ companyId, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/marketing-materials`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response.data);

export const getCompanyUsers = ({ companyId, userEmail }) =>
  axios
    .get(`${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/users`, {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    })
    .then(response => response.data);

export const getCompanyEnterpriseAdmins = ({ companyId, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/enterprise-admins`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response.data);

export const getCompanyUsersByJwt = () =>
  axios
    .get(`${process.env.REACT_APP_API_GATEWAY}/user`, {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${getSearchParamValue("email")}`)}`,
      },
    })
    .then(response => response.data);

export const getModelById = ({ modelId, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/level/portfolioBuilder/${modelId}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response.data);

export const getSuperAdminData = email =>
  axios
    .get(`${process.env.REACT_APP_HOME_API_DOMAIN}/getSuperAdminData`, {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${email}`)}`,
      },
    })
    .then(response => response.data);

export const getUserMetadata = userEmail =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/auth/V2`,
      {},
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response.data);

export const getUserTypes = () =>
  axios
    .get(`${process.env.REACT_APP_API_GATEWAY}/user/types`, {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${getSearchParamValue("email")}`)}`,
      },
    })
    .then(response => response.data);

export const loginCompanyUser = ({ email, password }) =>
  axios
    .post(`${process.env.REACT_APP_API_GATEWAY}/auth/V2`, {
      email,
      password,
    })
    .then(response => {
      const jwt = response.data?.jwt;

      Cookies.set(`jwt__${decodeURIComponent(email.toLowerCase())}`, jwt, {
        expires: 0.5, // half a day (12 hours)
        secure: true,
      });

      return response.data;
    });

export const removeFavoriteFinancialProduct = ({ productId, userEmail }) =>
  axios.delete(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/favoriteFinancialProducts/${productId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const removeFavoriteSecurities = ({ productId, userEmail }) =>
  axios.delete(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/favoriteSecurities/${productId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const resetCompanyUserPassword = ({
  companyId,
  companyUserId,
  userEmail,
}) =>
  axios.post(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/users/${companyUserId}/reset-password`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateCompany = ({ companyId, requestPayload, userEmail }) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const uploadCompanyLogoByID = ({
  companyId,
  requestPayload,
  userEmail,
}) =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/logo`,
      requestPayload,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response.data);

export const updateCompanySettingsByID = ({
  companyId,
  requestPayload,
  userEmail,
}) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/settings`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateCompanyUserBySuperadmin = ({
  companyId,
  companyUserId,
  requestPayload,
  userEmail,
}) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/users/${companyUserId}`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateEnabledInvestmentsForAdmin = ({
  companyId,
  requestPayload,
  userEmail,
}) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/companies/${companyId}/products`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );
